export const POLYGON_COLORS = {
    "a":"#33a02c",
    "b":"#cecece",
    "c":"white",
    "d":"#ffff00",
    "h":"#33a02c",
    "i":"#cecece",
    "j":"white",
    "k":"#ff0000",
    "n":"red",
    "o":"#33a02c",
    "p":"#99cccc",
    "g":"#ffff00",
    "q":"white",
    "r":"#1016cc",
    "s":"white",
    "t":"white",
    "u":"white",
    "v":"white",
    "w":"white",
    "x":"white",
    "y":"white",
    "z":"white",
    "aa":"#ffff00",
    "bb":"#ffff00",
    "hh":"red",
    "ii":"red",
    "pa":"white",
    "pb":"white",
    "pc":"white",
    "pd":"white",
    "me":"white",
    "mf":"white",
    "mg":"white",
    "mh":"white",
    "gi":"white",
    "gj":"white",
    "gk":"white",
    "gl":"white",
    "bm":"white",
    "bn":"white",
    "bo":"white",
    "bp":"white",
    "nq":"white",
    "nr":"white",
    "ns":"white",
    "nt":"white",
    "fu":"white",
    "fv":"white",
    "fw":"white",
    "fx":"#52fa6c",
    "uu":"blue",
    "oo":"blue",
    "pp":"blue"
}